/**
 * OZONE — B2B cart progress UX. Syncs Liquid markup after Impulse AJAX cart rebuilds.
 */
(function () {
  function parseSource(text) {
    var wrap = document.createElement('div');
    wrap.innerHTML = text;
    return wrap.querySelector('[data-eoo-b2b-progress-source]');
  }

  function setCheckoutEnabled(form, enabled) {
    if (!form) return;
    form.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      if (enabled) {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
      } else {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.remove('btn--loading');
      }
    });
    form.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
      el.hidden = !enabled;
    });
  }

  function setReplaceSubtotal(form, progress) {
    if (!form) return;
    var replace = progress && progress.getAttribute('data-replace-subtotal') === 'true';
    form.classList.toggle('eoo-b2b-totals-active', !!replace);
  }

  function applyProgress(form, source) {
    var slot = form.querySelector('[data-eoo-b2b-progress-slot]');
    if (!slot) return;
    var progressNode = source ? source.querySelector('[data-eoo-b2b-progress]') : null;
    if (!progressNode) {
      slot.innerHTML = '';
      setCheckoutEnabled(form, true);
      setReplaceSubtotal(form, null);
      return;
    }
    slot.innerHTML = source.innerHTML;
    var progress = slot.querySelector('[data-eoo-b2b-progress]');
    var canCheckout = progress && progress.getAttribute('data-can-checkout') === 'true';
    setCheckoutEnabled(form, canCheckout);
    setReplaceSubtotal(form, progress);
  }

  function syncFromAjaxText(text) {
    var source = parseSource(text);
    document.querySelectorAll('[data-location]').forEach(function (form) {
      applyProgress(form, source);
    });
  }

  function bindForm(form) {
    if (!form || form.dataset.eooB2bBound === 'true') return;
    form.dataset.eooB2bBound = 'true';
    form.addEventListener(
      'submit',
      function (evt) {
        var progress = form.querySelector('[data-eoo-b2b-progress]');
        if (progress && progress.getAttribute('data-can-checkout') === 'false') {
          evt.preventDefault();
          evt.stopPropagation();
          var btn = form.querySelector('[name="checkout"]');
          if (btn) btn.classList.remove('btn--loading');
        }
      },
      true
    );
    var progress = form.querySelector('[data-eoo-b2b-progress]');
    if (progress) {
      setCheckoutEnabled(form, progress.getAttribute('data-can-checkout') === 'true');
      setReplaceSubtotal(form, progress);
    }
  }

  function init() {
    document.querySelectorAll('#CartDrawerForm, #CartPageForm').forEach(bindForm);

    if (window.theme && theme.CartForm && theme.CartForm.prototype && !theme.CartForm.prototype.eooB2bPatched) {
      var proto = theme.CartForm.prototype;
      var original = proto.cartMarkup;
      proto.cartMarkup = function (text) {
        original.call(this, text);
        syncFromAjaxText(text);
      };
      proto.eooB2bPatched = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
